import unidecode from "unidecode";

export function toLowercaseAscii(string) {
  return unidecode(string).toLowerCase();
}

function trimAccents(string) {
  if (string == null) return [null, null];
  let trimmed = string.trim().replace(/\s+/g, " ");
  return [trimmed, toLowercaseAscii(trimmed)];
}

export function baseEquals(a, b) {
  return toLowercaseAscii(a) === toLowercaseAscii(b);
}

export default trimAccents;
